import axios from '@/libs/api.request'
import fileAxios from '@/libs/file.request'

// 个人会员列表
export const apiPersonMemberList = data => {
  return axios.request({
    url: '/admin/personal-member',
    method: 'get',
    data,
  })
}

// 个人会员详情
export const apiPersonMemberDetail = (id, data) => {
  return axios.request({
    url: `/admin/personal-member/${id}`,
    method: 'get',
    data,
  })
}
// 个人会员编辑
export const apiPersonMemberUpdate = (id, data) => {
  return axios.request({
    url: `/admin/personal-member/${id}`,
    method: 'put',
    data,
  })
}
// 个人会员删除
export const apiPersonMemberDelete = (id, data) => {
  return axios.request({
    url: `/admin/personal-member/${id}`,
    method: 'delete',
    data,
  })
}
// 个人会员审核
export const apiPersonMemberRemark = (id, data) => {
  return axios.request({
    url: `/admin/personal-member/${id}`,
    method: 'patch',
    data,
  })
}
// 个人内容下载，type:1下载资料，2下载内容
export const apiPersonMemberDownload = (type, id, data) => {
  return fileAxios.request({
    url: type == 1 ? `/admin/personal-member-download-zip/${id}` : `/admin/personal-member-download/${id}`,
    method: 'get',
    data,
  })
}
// 获取地址
export const apiRegionList = data => {
  return axios.request({
    url: `/admin/area`,
    method: 'get',
    data,
  })
}

// 单位会员列表
export const apiCompanyMemberList = data => {
  return axios.request({
    url: '/admin/unit-member',
    method: 'get',
    data,
  })
}

// 单位会员详情
export const apiCompanyMemberDetail = (id, data) => {
  return axios.request({
    url: `/admin/unit-member/${id}`,
    method: 'get',
    data,
  })
}
// 单位会员编辑
export const apiCompanyMemberUpdate = (id, data) => {
  return axios.request({
    url: `/admin/unit-member/${id}`,
    method: 'put',
    data,
  })
}
// 单位会员审核
export const apiCompanyMemberRemark = (id, data) => {
  return axios.request({
    url: `/admin/unit-member/${id}`,
    method: 'patch',
    data,
  })
}
// 单位会员删除
export const apiCompanyMemberDelete = (id, data) => {
  return axios.request({
    url: `/admin/unit-member/${id}`,
    method: 'delete',
    data,
  })
}
// 单位内容下载，type:1下载资料，2下载内容
export const apiCompanyMemberDownload = (type, id, data) => {
  return fileAxios.request({
    url: type == 1 ? `/admin/unit-member-download-zip/${id}` : `/admin/unit-member-download/${id}`,
    method: 'get',
    data,
  })
}

// 职位列表
export const apiPositionList = data => {
  return axios.request({
    url: '/admin/committee-member',
    method: 'get',
    data,
  })
}

// 职位详情
export const apiPositionDetail = (id, data) => {
  return axios.request({
    url: `/admin/committee-member/${id}`,
    method: 'get',
    data,
  })
}
// 职位编辑
export const apiPositionUpdate = (id, data) => {
  return axios.request({
    url: `/admin/committee-member/${id}`,
    method: 'put',
    data,
  })
}
// 职位审核
export const apiPositionRemark = (id, data) => {
  return axios.request({
    url: `/admin/committee-member/${id}`,
    method: 'patch',
    data,
  })
}
// 职位删除
export const apiPositionDelete = (id, data) => {
  return axios.request({
    url: `/admin/committee-member/${id}`,
    method: 'delete',
    data,
  })
}
// 职位内容下载，type:1下载资料，2下载内容
export const apiPositionDownload = (type, id, data) => {
  return fileAxios.request({
    url: type == 1 ? `/admin/committee-member-download-zip/${id}` : `/admin/committee-member-download/${id}`,
    method: 'get',
    data,
  })
}
